import {
  CONTENT_LIB_SET_GROUP_COPY_CONFIRM_ACTION,
  CONTENT_LIB_SET_GROUPS_SEARCH_RESULT_ACTION,
  CONTENT_LIB_SET_LANGS_ACTION,
  CONTENT_LIB_SET_LOCKED_MODE_ACTION,
  CONTENT_LIB_SET_SEARCH_FILTER_ACTION,
  CONTENT_LIB_SET_SELECTED_GROUP_ACTION,
  CONTENT_LIB_SET_VIDEO_COPY_CONFIRM_ACTION,
  CONTENT_LIB_SET_VIDEO_POPUP_ACTION,
  CONTENT_LIB_SET_VIEW_MODE_ACTION,
  EContentLibViewMode,
  IContentLibCopyGroupConfirm,
  IContentLibCopyVideoConfirm,
  IContentLibGroupsSearchResult,
  IContentLibSearchFilter,
  IContentLibSetGroupCopyConfirmAction,
  IContentLibSetGroupsSearchResultAction,
  IContentLibSetLangsAction,
  IContentLibSetLockedModeAction,
  IContentLibSetSearchFilterAction,
  IContentLibSetSelectedGroupIdAction,
  IContentLibSetVideoCopyConfirmAction,
  IContentLibSetVideoPopupAction,
  IContentLibSetViewModeAction,
  IContentLibVideoPopup,
  TContentLibLangs,
  IContentLibVideo,
  IContentLibSetVideosSearchResultAction,
  CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_ACTION,
  IContentLibCategory,
  CONTENT_LIB_SET_CATEGORIES_ACTION,
  IContentLibSetCategoriesAction,
  IContentLibSetSelectedCategoryIdAction,
  CONTENT_LIB_SET_SELECTED_CATEGORY_ACTION,
  IContentLibSetOpenCategoriesAction,
  CONTENT_LIB_SET_OPEN_CATEGORIES_ACTION,
  IContentLibUpdateVideoAction,
  CONTENT_LIB_UPDATE_VIDEO_ACTION,
  TContentLibVideoUpdate, IContentLibShowFirstGroupIdCreatedAction, CONTENT_LIB_SHOW_FIRST_GROUP_CREATED_MESSAGE_ACTION
} from './types';

export class ContentLibActions {

  public static setGroupsSearchResult(
    groupsSearchResult: Partial<IContentLibGroupsSearchResult>
  ): IContentLibSetGroupsSearchResultAction {
    return {
      type: CONTENT_LIB_SET_GROUPS_SEARCH_RESULT_ACTION,
      groupsSearchResult
    }
  }

  public static setVideosSearchResult(
    videosSearchResult: IContentLibVideo[]
  ): IContentLibSetVideosSearchResultAction {
    return {
      type: CONTENT_LIB_SET_VIDEOS_SEARCH_RESULT_ACTION,
      videosSearchResult,
    }
  }

  public static setSearchFilter(
    searchFilter: Partial<IContentLibSearchFilter>
  ): IContentLibSetSearchFilterAction {
    return {
      type: CONTENT_LIB_SET_SEARCH_FILTER_ACTION,
      searchFilter
    }
  }

  public static setViewMode(
    viewMode: EContentLibViewMode
  ): IContentLibSetViewModeAction {
    return {
      type: CONTENT_LIB_SET_VIEW_MODE_ACTION,
      viewMode
    }
  }

  public static setVideoPopup(
    videoPopup: Partial<IContentLibVideoPopup>
  ): IContentLibSetVideoPopupAction {
    return {
      type: CONTENT_LIB_SET_VIDEO_POPUP_ACTION,
      videoPopup
    }
  }

  public static setCopyVideoConfirm(
    copyVideoConfirm: Partial<IContentLibCopyVideoConfirm>
  ): IContentLibSetVideoCopyConfirmAction {
    return {
      type: CONTENT_LIB_SET_VIDEO_COPY_CONFIRM_ACTION,
      copyVideoConfirm
    }
  }

  public static setCopyGroupConfirm(
    copyGroupConfirm: Partial<IContentLibCopyGroupConfirm>
  ): IContentLibSetGroupCopyConfirmAction {
    return {
      type: CONTENT_LIB_SET_GROUP_COPY_CONFIRM_ACTION,
      copyGroupConfirm
    }
  }

  public static setSelectedGroupId(
    selectedGroupId: number
  ): IContentLibSetSelectedGroupIdAction {
    return {
      type: CONTENT_LIB_SET_SELECTED_GROUP_ACTION,
      selectedGroupId
    }
  }

  public static setLangs(
    langs: TContentLibLangs
  ): IContentLibSetLangsAction {
    return {
      type: CONTENT_LIB_SET_LANGS_ACTION,
      langs
    }
  }

  public static setLockedMode(
    lockedMode: boolean
  ): IContentLibSetLockedModeAction {
    return {
      type: CONTENT_LIB_SET_LOCKED_MODE_ACTION,
      lockedMode
    }
  }

  public static setCategories(
    categories: IContentLibCategory[]
  ): IContentLibSetCategoriesAction {
    return {
      type: CONTENT_LIB_SET_CATEGORIES_ACTION,
      categories
    }
  }

  public static setSelectedCategoryId(
    selectedCategoryId: number
  ): IContentLibSetSelectedCategoryIdAction {
    return {
      type: CONTENT_LIB_SET_SELECTED_CATEGORY_ACTION,
      selectedCategoryId
    }
  }

  public static setOpenCategories (
    isOpenCategories: boolean
  ): IContentLibSetOpenCategoriesAction {
    return {
      type: CONTENT_LIB_SET_OPEN_CATEGORIES_ACTION,
      isOpenCategories
    }
  }

  public static updateVideo (
    id: number,
    updateData: TContentLibVideoUpdate
  ): IContentLibUpdateVideoAction {
    return {
      type: CONTENT_LIB_UPDATE_VIDEO_ACTION,
      id,
      updateData
    }
  }

  public static setShowFirstGroupIdCreatedMessage (
    showFirstGroupCreatedMessage: number
  ): IContentLibShowFirstGroupIdCreatedAction {
    return {
      type: CONTENT_LIB_SHOW_FIRST_GROUP_CREATED_MESSAGE_ACTION,
      showFirstGroupIdCreatedMessage: showFirstGroupCreatedMessage
    }
  }




}